export const skillsData = [
  {
    id: 1,
    name: "JavaScript",
    logo: "javascript.png",
  },
  {
    id: 2,
    name: "TypeScript",
    logo: "typescript.png",
  },
  {
    id: 3,
    name: "React",
    logo: "React.png",
  },
  {
    id: 4,
    name: "Sass",
    logo: "Sass.png",
  },
  {
    id: 5,
    name: "HTML",
    logo: "html.svg",
  },
  {
    id: 6,
    name: "CSS",
    logo: "CSS.svg",
  },
  {
    id: 7,
    name: "Git",
    logo: "Git.png",
  },
  {
    id: 8,
    name: "Bitbucket",
    logo: "bitbucket.svg",
  },
  {
    id: 9,
    name: "Bootstrap",
    logo: "bootstrap.png",
  },
  {
    id: 10,
    name: "Postman",
    logo: "postman.svg",
  },
  {
    id: 11,
    name: "Styled Components",
    logo: "styled-component.svg",
  },
  {
    id: 12,
    name: "Jest",
    logo: "Jest.png",
  },
  {
    id: 13,
    name: "Testing Library",
    logo: "Testing-library.png",
  },
  {
    id: 14,
    name: "Docker",
    logo: "Docker.png",
  },

];
